// lang-es.ts

export const LANG_ES_NAME = 'es';


export const LANG_ES_TRANS = {
  'hello world': 'hola mundo',

};



// WEBPACK FOOTER //
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/translate/lang-es.ts